import React from "react";
import { translate } from "../../../i18n";

function FullScreenButton({
    t, item, styles
}) {
    return null
}

export default translate(FullScreenButton);